// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener('cart:item-added', function (evt) {
  console.log('Item added to the cart');
  console.log(evt.detail.product);
}); // This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener('cart:updated', function (evt) {
  console.log('Cart updated');
  console.log(evt.detail.cart);
}); // This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.

document.addEventListener('cart:error', function (evt) {
  console.log('Cart error');
  console.log(evt.detail.errorMessage);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener('quick-cart:open', function (evt) {
  console.log('Quick cart opened');
  console.log(evt.detail.cart);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.

document.addEventListener('quick-cart:close', function () {
  console.log('Quick cart closed');
}); // This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.

document.addEventListener('product:variant-change', function (evt) {
  console.log('Product variant changed');
  console.log(evt.detail.variant);
}); // This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.

document.addEventListener('product:quantity-update', function (evt) {
  console.log('Product quantity updated');
  console.log(evt.detail.quantity, evt.detail.variant);
});


$(document).ready(function(){

//   document.addEventListener('product:quantity-update', function (evt) {
//     console.log('Product quantity updated');
//     console.log(evt.detail.quantity, evt.detail.variant);
//   });
  
  
  $(".drawer-menu__panel .drawer-menu__primary-links li a").click(function(e){
    e.preventDefault();
    var anchor_link = $(this).attr("href");
    //if it has anchor link
    if ( anchor_link.indexOf("shopify-section-template") > -1 ){
      // if drawer menu is open
      if ( $(".drawer-menu.popover").hasClass("active")){        
        $(".drawer-menu__close-icon").trigger("click");
      }
      // end if drawer menu is open

      var target_page = anchor_link.split("#")[0];
      console.log(target_page.length);
      var current_location = window.location.href;
      console.log(current_location.length);
      var section_id = anchor_link.split("#")[1];
      var aTag = $("#" + section_id );
      if ( $("body").hasClass("header-sticky") ){
        if ( target_page.length == current_location.length ){
          var header_height = $("#shopify-section-header").height();
          $('html,body').animate({scrollTop: ( aTag.offset().top - header_height - 20 ) },'slow');  
        }else{
          window.location.href = anchor_link;
//           $('html,body').animate({scrollTop: ( aTag.offset().top - header_height - 20 ) },'slow');  
        }
        
      }else{
        $('html,body').animate({scrollTop: aTag.offset().top},'slow');
      }
      
      
      
    }else{
      window.location.href = anchor_link;
    }

  });
  
  
//   var getParentAnchor = function (element) {
//     while (element !== null) {
//       if (element.tagName && element.tagName.toUpperCase() === "A") {
//         return element;
//       }
//       element = element.parentNode;
//     }
//     return null;
//   };
  
//   document.addEventListener('click', function(e) {    
//     var anchor = getParentAnchor(e.target);
//     console.log(anchor);
//     var link = e.attr('href');
//     console.log(link);
//     if(anchor !== null) {
// //       if ( anchor.indexOf("shopify-section-template") > -1 ){
// //         window.event.preventDefault();
// //         console.log(anchor);        
// //       }else{
      
// //       }
//     }
//   }, false);
  
})